module.exports = __webpack_public_path__ + "static/media/Rectangle 190.058dfca1.svg";